export default __webpack_public_path__ + "static/media/icon-search-color-accent.3aee2109.svg";